import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MachineService } from '../../../core/_base/layout';

@Component({
  selector: 'kt-machine',
  templateUrl: './machine.component.html',
  styleUrls: ['./machine.component.css']
})
export class MachineComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private machineService: MachineService
  ) {}

  ngOnInit(): void {
    const machine = this.route.parent && this.route.parent.snapshot.data['machine'];
    if (!machine) {
      this.router.navigate(['/machine-list'], { queryParams: { error: 'machine_not_found' }, replaceUrl: false });
      return;
    }
    this.machineService.setMachine(machine);
  }

}
